module.exports = __webpack_public_path__ + "static/media/clockShield.d450216b.svg";